import React, { useState, useEffect } from 'react';

interface SearchInputProps {
  onSearch: (term: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const initialRender = React.useRef(true); // 新增一個 ref 來追蹤是否為初次渲染

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return; // 初次渲染時不執行搜尋
    }

    if (!searchTerm && !initialRender.current) {
      // 如果搜尋詞為空且不是初次渲染，則不觸發搜尋
      return;
    }

    const handler = setTimeout(() => {
      onSearch(searchTerm);
    }, 300); // Debounce for 300ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, onSearch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <input
      type="text"
      placeholder="依書名搜尋..."
      value={searchTerm}
      onChange={handleChange}
      style={{ padding: '8px', width: '300px', marginBottom: '20px' }}
    />
  );
};

export default SearchInput;